<template>
  <div class="progress-card">
    <v-card elevation="0" class="pa-3" @click="clickedCard">
      <div class="d-flex flex-row">
        <v-icon :class="'icon-background icon-background-' + progressColor" :color="progressColor">{{ icon }}</v-icon>

        <v-card-text v-if="showInfoText" class="pa-2">
          <h5 :class="'mb-0 mt-1 ' + progressColor + '--text'">{{ infoText }}</h5>
        </v-card-text>

        <!-- TODO uncomment when needed -->
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="grey">more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>Funktion 1</v-list-item>
            <v-list-item>Funktion 2</v-list-item>
          </v-list>
        </v-menu> -->
      </div>

      <v-card-title class="pl-0">
        {{ title }}
      </v-card-title>

      <v-card-subtitle v-if="!hideProgressBar" class="pl-0">
        <v-progress-linear :color="progressColor" :value="progressValue"></v-progress-linear>
      </v-card-subtitle>
      <v-card-text class="pl-0">
        {{ text }}
      </v-card-text>
      <v-card-actions class="pl-0">
        <v-btn :color="progressColor" class="white--text" small @click.native.stop="btnAction" elevation="0">
          {{ btnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import DesignUtils from "@/modules/core/services/design-utils";

export default {
  name: 'ProgressCard',
  props: {
    icon: String, // small image that will be shown in the left corner
    iconColor: String, // color of icon
    title: String, // card title
    progressValue: Number, // value of progress bar
    text: String, // additional text for card
    btnColor: String, // color of action button
    btnText: String, // text of action button
    hideProgressBar: Boolean,
    showInfoText: Boolean,
    infoText: String //Info text to display beside icon
  },
  computed: {
    progressColor() {
      return DesignUtils.getProgressColor(this.progressValue, null, null, null, null);
    }
  },
  methods: {
    btnAction() {
      this.$emit('onClick');
    },
    clickedCard() {
      this.$emit('clickedCard');
    }
  }
}
</script>
<style src="./ProgressCard.scss" lang="scss"/>